<template>
  <v-container class="fl;uid ma-0 pa-0" >
    <v-row  >
      <v-col cols="12">
        <app-title>Commissions Rules</app-title>
        <v-btn small color="success" @click="editMode = true">Edit</v-btn>
        <v-btn small v-if="editMode" color="primary" @click="save">Save</v-btn>
      </v-col>
      <v-tooltip bottom v-on.stop:"loaded">
        
      </v-tooltip>
      <v-col cols="12">
        <commission-rule
          ref="rules"
          @rulesLoaded="loaded"
          :editMode="editMode"
          @rulesSaved="editMode = false"
        ></commission-rule>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CommissionRule from "@/components/commissions/CommissionRule";
export default {
  name: "CommissionsRules",
  data() {
    return {
      editMode: false
    };
  },
  components: {
    CommissionRule
  },
  methods: {
    loaded(val) {
    },
    save() {
      this.$refs.rules.saveRules();
    }
  },
  mounted() {
    this.$refs.rules.loadRules();
  }
};
</script>

<style scoped>
</style>